import React from 'react';
import { KBBlock } from '../../../types';

import HeadingBlock from './HeadingBlock';
import ParagraphBlock from './ParagraphBlock';
import CodeBlockComp from './CodeBlockComp';
import ImageBlock from './ImageBlock';
import TableBlock from './TableBlock';
import CalloutBlock from './CalloutBlock';
import ChecklistBlock from './ChecklistBlock';
import ListBlock from './ListBlock';
import ToggleBlock from './ToggleBlock';
import VideoBlock from './VideoBlock';
import DividerBlock from './DividerBlock';
import SpacerBlock from './SpacerBlock';
import ProgressBlock from './ProgressBlock';
import StatusBadgeBlock from './StatusBadgeBlock';
import FileAttachmentBlock from './FileAttachmentBlock';
import TableOfContentsBlock from './TableOfContentsBlock';
import BookmarkBlock from './BookmarkBlock';
import MarkdownBlock from './MarkdownBlock';

interface Props {
  block: KBBlock;
  isEditing: boolean;
  onChange: (updates: Partial<KBBlock>) => void;
  onFinish: () => void;
  allBlocks?: KBBlock[];
}

const BlockRenderer: React.FC<Props> = ({ block, isEditing, onChange, onFinish, allBlocks }) => {
  const common = { block, isEditing, onChange, onFinish };

  switch (block.type) {
    case 'heading_1':
    case 'heading_2':
    case 'heading_3':
      return <HeadingBlock {...common} />;

    case 'paragraph':
      return <ParagraphBlock {...common} />;

    case 'code':
      return <CodeBlockComp {...common} />;

    case 'image':
      return <ImageBlock {...common} />;

    case 'table':
      return <TableBlock {...common} />;

    case 'callout':
      return <CalloutBlock {...common} />;

    case 'checklist':
      return <ChecklistBlock {...common} />;

    case 'bullet_list':
    case 'ordered_list':
      return <ListBlock {...common} />;

    case 'toggle':
      return <ToggleBlock {...common} />;

    case 'video':
      return <VideoBlock {...common} />;

    case 'divider':
      return <DividerBlock {...common} />;

    case 'spacer':
      return <SpacerBlock {...common} />;

    case 'progress':
      return <ProgressBlock {...common} />;

    case 'status_badge':
      return <StatusBadgeBlock {...common} />;

    case 'file':
      return <FileAttachmentBlock {...common} />;

    case 'table_of_contents':
      return <TableOfContentsBlock {...common} allBlocks={allBlocks} />;

    case 'bookmark':
      return <BookmarkBlock {...common} />;

    case 'markdown':
      return <MarkdownBlock {...common} />;

    default:
      return (
        <div className="text-xs text-gray-400 italic px-2 py-1 border border-dashed border-gray-200 rounded">
          Unsupported block type: {block.type}
        </div>
      );
  }
};

export default BlockRenderer;
